// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Slider.module.scss  */
.Slider-module-Root_e3t {
  position: relative;
  margin: -8px;
  padding: 8px; }

.Slider-module-Carousel_2fC {
  position: relative;
  overflow: hidden; }

.Slider-module-Arrow_x86 {
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translate(0, -50%); }

.Slider-module-ArrowNext_20e {
  right: 0; }

.Slider-module-ArrowPrev_3Np {
  left: 0; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Slider/Slider.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,6BAA6B,EAAE;;AAEjC;EACE,QAAQ,EAAE;;AAEZ;EACE,OAAO,EAAE","sourcesContent":["/*  imported from Slider.module.scss  */\n.Slider-module-Root_e3t {\n  position: relative;\n  margin: -8px;\n  padding: 8px; }\n\n.Slider-module-Carousel_2fC {\n  position: relative;\n  overflow: hidden; }\n\n.Slider-module-Arrow_x86 {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  transform: translate(0, -50%); }\n\n.Slider-module-ArrowNext_20e {\n  right: 0; }\n\n.Slider-module-ArrowPrev_3Np {\n  left: 0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
